import { CheckoutDetails, CheckoutStatus } from '@ancon/wildcat-types'
import isPreOrderSharable from '@ancon/wildcat-utils/preOrder/isPreOrderSharable'

import isSystemProductOrder from './isSystemProductOrder'

/**
 * Whether a checkout Core has given up on can be swapped for a fresh one with
 * the same items.
 *
 * Core's `CancelCheckoutJob` cancels a checkout whose payment was left open
 * too long. A Canceled checkout can neither be updated nor paid, so the cart
 * is a dead end until it is replaced. Pre-orders, group orders, gift card
 * purchases and wallet top-ups are left alone: they carry links, attendees or
 * metadata that a plain create would lose.
 */
export default function isRecreatableCheckout(
  checkout: CheckoutDetails | null | undefined,
): checkout is CheckoutDetails {
  if (checkout?.status !== CheckoutStatus.Canceled) {
    return false
  }

  if (
    isPreOrderSharable(checkout) ||
    isSystemProductOrder(checkout.orderFormat)
  ) {
    return false
  }

  return !!checkout.attendees?.[0]?.items?.length
}
